export const roundIconButtonSX = {
  width: 30,
  height: 30,
  borderRadius: "50%",
  padding: "6px",
  backgroundColor: "#F2F2F2",
  boxShadow: "0px 3px 6px #00000029",
  "&:hover": {
    backgroundColor: "#E6E6E6",
  },
};
